/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ZoningInputs */

const en_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoning Information`)
};

const es_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información de zonificación`)
};

const fr_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations de zonage`)
};

const de_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bebauungsplaninformationen`)
};

const ja_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用途地域情報`)
};

const zh_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地分区信息`)
};

const ar_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلومات تقسيم المناطق`)
};

const id_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informasi Zonasi`)
};

const it_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni sulla Zonizzazione`)
};

const ru_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зонирование территории`)
};

const pt_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações de Zoneamento`)
};

const ko_field_zoning = /** @type {(inputs: Field_ZoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지역 지구 정보`)
};

/**
* | output |
* | --- |
* | "Zoning Information" |
*
* @param {Field_ZoningInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_zoning = /** @type {((inputs?: Field_ZoningInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ZoningInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_zoning(inputs)
	if (locale === "es") return es_field_zoning(inputs)
	if (locale === "fr") return fr_field_zoning(inputs)
	if (locale === "de") return de_field_zoning(inputs)
	if (locale === "ja") return ja_field_zoning(inputs)
	if (locale === "zh") return zh_field_zoning(inputs)
	if (locale === "ar") return ar_field_zoning(inputs)
	if (locale === "id") return id_field_zoning(inputs)
	if (locale === "it") return it_field_zoning(inputs)
	if (locale === "ru") return ru_field_zoning(inputs)
	if (locale === "pt") return pt_field_zoning(inputs)
	return ko_field_zoning(inputs)
});